package one.healthium.login.ui.login

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.UserInteractor
import one.healthium.domain.user.models.SignInOptions
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

class LoginViewModel(
    private val userInteractor: UserInteractor,
) : BaseViewModel() {

    private val _state = MutableStateFlow(LoginUiState())
    val state = _state.asStateFlow()

    val messages = UiMessageManager()

    fun onSignInClicked(options: SignInOptions) {
        launch {
            try {
                _state.update { state -> state.copy(loading = true) }
                val user = userInteractor.signIn(options)
                _state.update { state -> state.copy(user = user) }
            } catch (e: Exception) {
                Logger.e("signIn error", e)
                messages.add(UiMessage.throwable(e))
            } finally {
                _state.update { state -> state.copy(loading = false) }
            }
        }
    }

    fun onUsernameChanged(value: String) {
        _state.update { state -> state.copy(signInOptions = state.signInOptions.copy(username = value.trim())) }
    }

    fun onPasswordChanged(value: String) {
        _state.update { state -> state.copy(signInOptions = state.signInOptions.copy(password = value.trim())) }
    }
}
